import { Api } from '@/core/api.js'
import Vue from 'vue'

const api = new Api()

const state = {
    data: false,
}

const getters = {
    getData(state, getters, rootState) {
        return state.data
    }
}

const actions = {
    loadData(context, date) {
        return api.get(`sales/resume/${date}`).then(function(response) {
            context.commit('setData', response)
            return response.data
        })
    },
}

const mutations = {
    setData(state, data) {
        state.data = data
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
